<aside class="block__left-side-panel">
    <div class="text-items">
        <h1 class="text-items__title">{{'ACCOUNT_EMAIL_CHANGE' | translate}}</h1>
        <p class="text-items__description" innerHtml="{{'ACCOUNT_EMAIL_CHANGE_DETAILS_HTML' | translate}}"></p>
    </div>
</aside>
